import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=4516e61c&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=4516e61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4516e61c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4516e61c')) {
      api.createRecord('4516e61c', component.options)
    } else {
      api.reload('4516e61c', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=4516e61c&scoped=true&", function () {
      api.rerender('4516e61c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Vybq72QuJ8Ln/JS/comp/GuestBoxKids.vue"
export default component.exports